<template>
  <div>
    <div>
      <div class="biaoqian">仓库列表</div>
      <div style="display: flex;justify-content: space-between;">
        <div style="width: 250px;display: flex;align-items: center;margin-bottom: 20px;">
          <div style="width: 50px;">搜索:</div>
          <el-input placeholder="请输入内容" v-model="findshop" size="small">
            <el-button slot="append" icon="el-icon-search" @click="find_fc"></el-button>
          </el-input>
        </div>
        <div>
          <el-button type="success" icon="el-icon-circle-plus-outline" size="medium" style="height: 35px;"
            @click="ku_add=true">新建仓库
          </el-button>
        </div>

      </div>
      <el-dialog title="新建仓库" :visible.sync="ku_add" :close-on-click-modal="false" :close-on-press-escape="false"
        :before-close="ku_add_close" >
        <add></add>
      </el-dialog>

      <el-row :gutter="20">
        <div v-for="(item,i) in ku_list" :key="i">
          <el-col :sm="12" :xs="24" :md="8" :lg="6">
            <el-card class="box-card" style="border-radius:10px;margin:5px;" shadow="never">
              <div style="text-align: center;">
                <el-image style="width: 150px; height: 150px" :src="item.image"></el-image>
              </div>
              <div style="font-weight:600;font-size: 15px;">{{item.name}}</div>
              <div style="font-size: 12px;color:#888" v-if="item.other">{{item.other}}</div>
              <div style="font-size: 12px;color:#888" v-else>-</div>

              <el-tag size="mini">素材数量: {{item.spnum}}</el-tag>
              <div style="margin-top: 20px;">
                <el-button style="width: 100%;" size="small" type="primary">制作</el-button>
              </div>

            </el-card>
          </el-col>
        </div>
      </el-row>
      <div style="margin-top: 10px;">
        <el-pagination background layout="total,prev, pager, next" :total="total" @current-change="fy_page"
          :current-page="page">
        </el-pagination>
      </div>

      <!-- <div style="display:flex;justify-content: flex-start;flex-wrap: wrap;">
        <div style="width: 200px;margin:10px;" v-for="(item,i) in ku_list" :key="i">
          <el-card class="box-card" style="border-radius:10px;" shadow="never">
            <div>
              <el-image style="width: 100%; height: 150px" :src="item.image"></el-image>
            </div>
            <div style="font-weight:600;font-size: 14px;">{{item.name}}</div>
          </el-card>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import add from "../User/Videohome_add.vue"

export default {
  name: '',
  components: {
    add
  },
  // 定义属性
  data() {
    return {
      page: 1,
      ku_list: [],
      findshop: '',
      total: 0,
      ku_add: true
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    find_fc() {
      this.ku_list_fc(this.page)
    },
    fy_page(e) {
      this.ku_list_fc(e)
    },
    ku_list_fc(page) {
      const loading = this.$loading(this.$loadinginfo);
      var data = {
        'class': '',
        'find': this.findshop,
        'page': page
      }
      this.$ajax.post('/qhy/spk/ku_list', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        console.log(res.data)
        var jg = res.data
        if (res.data.status == 200) {
          var addlist = jg.data.data
          for (var i = 0; i < addlist.length; i++) {
            addlist[i]['image'] = 'https://ku.aiqihao.cn/' + addlist[i]['image']
          }
          this.ku_list = addlist
          this.total = jg.data.last_page * 10
          this.page = page
          loading.close();
        } else {
          this.$msg.error('获取失败')
        }
      })
    },
    ku_add_close(done) {
      this.$confirm('确认关闭创建窗口，关闭后填写数据将丢失')
        .then(_ => {
          // 关闭方法-上方传的参数done
          done();
        })
        .catch(_ => { });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.ku_list_fc(1)
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/User/Videohome.vue


// WEBPACK FOOTER //
// src/components/User/Videohome.vue